/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { ReactNode, useContext } from 'react';

import { IAbsoluteNavContainerViewProps } from './absolute-nav-container';

import Accordion from 'react-bootstrap/Accordion'
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import AccordionContext from "react-bootstrap/AccordionContext";






export const AbsoluteNavContainerView: React.FC<IAbsoluteNavContainerViewProps> = props => {

    const { 
        pr1categories, 
        Product1List, 
        Product1ListItem,
        pr2categories, 
        Product2List, 
        Product2ListItem,
        pr3categories, 
        Product3List, 
        Product3ListItem,
        pr4categories, 
        Product4List, 
        Product4ListItem,
        pr5categories, 
        Product5List, 
        Product5ListItem,
        sl2categories, 
        Slot2List, 
        Slot2ListItem,
        sl3categories, 
        Slot3List, 
        Slot3ListItem,
        sl4categories, 
        Slot4List, 
        Slot4ListItem,
        navTitle1,
        navTitle2,
        navTitle3,
        navTitle4
    
    } = props;

    function ContextAwareToggle({ 
    //@ts-ignore
        children, eventKey, callback 
    
    }) {
        
        const currentEventKey = useContext(AccordionContext);
      
        const decoratedOnClick = useAccordionToggle(
          eventKey,
          () => callback && callback(eventKey),
        );
      
        const isCurrentEventKey = currentEventKey === eventKey;
      
        return (
          <button
            type="button"
            className={isCurrentEventKey ? 'accordion-inner active' : 'accordion-inner notactive' }
            onClick={decoratedOnClick}
          >
            {children}
          </button>
        );
    }

   


    if (!pr1categories || pr1categories.length === 0) {
        props.context.telemetry.error('Product Nav is empty, module wont render');
        return null;
    }
    if (!pr2categories || pr2categories.length === 0) {
        props.context.telemetry.error('Obrien Nav is empty, module wont render');
        return null;
    }
    if (!pr3categories || pr3categories.length === 0) {
        props.context.telemetry.error('Obrien Nav is empty, module wont render');
        return null;
    }
    if (!pr4categories || pr4categories.length === 0) {
        props.context.telemetry.error('Obrien Nav is empty, module wont render');
        return null;
    }
    if (!pr5categories || pr5categories.length === 0) {
        props.context.telemetry.error('Obrien Nav is empty, module wont render');
        return null;
    }
    if (!sl2categories || sl2categories.length === 0) {
        props.context.telemetry.error('Slot2 Nav is empty, module wont render');
        return null;
    }
    if (!sl3categories || sl3categories.length === 0) {
        props.context.telemetry.error('Slot3 Nav is empty, module wont render');
        return null;
    }
    if (!sl4categories || sl4categories.length === 0) {
        props.context.telemetry.error('Slot4 Nav is empty, module wont render');
        return null;
    }
    return (
<>

        
        <Accordion key="0">
        <div className='navBar-mobile'>
            <li className="navbar-item">  

                {/*
                // @ts-ignore */}
                <ContextAwareToggle eventKey="0">
                    
                        <span>{navTitle1}</span>
                    
                </ContextAwareToggle>
                    
                <Accordion.Collapse className="accordion__content" eventKey="0">
                    <div>
                    

                    
                        
                            <Module {...Product1List}>
                                { pr1categories.map((pr1category: ReactNode, index: number) => {
                                    return (
                                        <Node {...Product1ListItem} key={index}>
                                            {pr1category}
                                        </Node>
                                    );
                                })}
                            </Module>

                        
                            <Module {...Product2List}>
                                { pr2categories.map((pr2category: ReactNode, index: number) => {
                                    return (
                                        <Node {...Product2ListItem} key={index}>
                                            {pr2category}
                                        </Node>
                                    );
                                })}
                            </Module>

                        
                            <Module {...Product3List}>
                                { pr3categories.map((pr3category: ReactNode, index: number) => {
                                    return (
                                        <Node {...Product3ListItem} key={index}>
                                            {pr3category}
                                        </Node>
                                    );
                                })}
                            </Module>
                       

                       
                            <Module {...Product4List}>
                                { pr4categories.map((pr4category: ReactNode, index: number) => {
                                    return (
                                        <Node {...Product4ListItem} key={index}>
                                            {pr4category}
                                        </Node>
                                    );
                                })}
                            </Module>


                    
                            <Module {...Product5List}>
                                { pr5categories.map((pr5category: ReactNode, index: number) => {
                                    return (
                                        <Node {...Product5ListItem} key={index}>
                                            {pr5category}
                                        </Node>
                                    );
                                })}
                            </Module>

                        

                    </div>
                </Accordion.Collapse>

            </li>

            
            {navTitle2 ? (
            <li>
                {/*
                // @ts-ignore */}
                <ContextAwareToggle eventKey="2">
                    <span>{navTitle2}</span>
                </ContextAwareToggle>
                    
                <Accordion.Collapse className="accordion__content" eventKey="2">
                    <div>
                        <Module {...Slot2List}>
                            { sl2categories.map((sl2category: ReactNode, index: number) => {
                                return (
                                    <Node {...Slot2ListItem} key={index}>
                                        {sl2category}
                                    </Node>
                                );
                            })}
                        </Module>
                    </div>
                </Accordion.Collapse>
            </li>
            ) : null}

            {navTitle3 ? (
            <li>
                {/*
                // @ts-ignore */}
                <ContextAwareToggle eventKey="3">
                    <span>{navTitle3}</span>
                </ContextAwareToggle>
                    
                <Accordion.Collapse className="accordion__content" eventKey="3">
                    <div>
                        <Module {...Slot3List}>
                            { sl3categories.map((sl3category: ReactNode, index: number) => {
                                return (
                                    <Node {...Slot3ListItem} key={index}>
                                        {sl3category}
                                    </Node>
                                );
                            })}
                        </Module>
                    </div>
                </Accordion.Collapse>
            </li>
            ) : null}

            {navTitle4 ? (
            <li>
                {/*
                // @ts-ignore */}
                <ContextAwareToggle eventKey="4">
                    <span>{navTitle4}</span> 
                </ContextAwareToggle>
                    
                <Accordion.Collapse className="accordion__content" eventKey="4">
                    <div>
                        <Module {...Slot4List}>
                            { sl4categories.map((sl4category: ReactNode, index: number) => {
                                return (
                                    <Node {...Slot4ListItem} key={index}>
                                        {sl4category}
                                    </Node>
                                );
                            })}
                        </Module>
                    </div>
                </Accordion.Collapse>
            </li>
            ) : null}

        </div>
        </Accordion>
        


        <ul className='navBar justify'>
            <li className='navbar-item'>
                <a 
                    //href={obrienLink}
                >
                    <span>{navTitle1}</span>
                </a>
                <div className='submenu'>
                    <div className='submenu-container flex-md justify'>
                        <div className='submenu-left forty-five'>
                            <Module {...Product1List}>
                                { pr1categories.map((pr1category: ReactNode, index: number) => {
                                    return (
                                        <Node {...Product1ListItem} key={index}>
                                            {pr1category}
                                        </Node>
                                    );
                                })}
                                <li className="image-holder"></li>
                            </Module>
                        </div>
                        <div className='submenu-right forty-five'>
                            <Module {...Product2List}>
                                { pr2categories.map((pr2category: ReactNode, index: number) => {
                                    return (
                                        <Node {...Product2ListItem} key={index}>
                                            {pr2category}
                                        </Node>
                                    );
                                })}
                                <li className="image-holder"></li>
                            </Module>
                            <Module {...Product3List}>
                                { pr3categories.map((pr3category: ReactNode, index: number) => {
                                    return (
                                        <Node {...Product3ListItem} key={index}>
                                            {pr3category}
                                        </Node>
                                    );
                                })}
                                <li className="image-holder"></li>
                            </Module>
                            <Module {...Product4List}>
                                { pr4categories.map((pr4category: ReactNode, index: number) => {
                                    return (
                                        <Node {...Product4ListItem} key={index}>
                                            {pr4category}
                                        </Node>
                                    );
                                })}
                                <li className="image-holder"></li>
                            </Module>
                        
                            <Module {...Product5List}>
                                { pr5categories.map((pr5category: ReactNode, index: number) => {
                                    return (
                                        <Node {...Product5ListItem} key={index}>
                                            {pr5category}
                                        </Node>
                                    );
                                })}
                                <li className="image-holder"></li>
                            </Module>
                        </div>
                    
                    </div>

                </div>
            </li>

            {navTitle2 ? (
            <li className="navbar-item">
                <a 
                    //href={supportLink}
                >
                    <span>{navTitle2}</span>
                </a>
                <div className="submenu">
                    <Module {...Slot2List}>
                        { sl2categories.map((sl2category: ReactNode, index: number) => {
                            return (
                                <Node {...Slot2ListItem} key={index}>
                                    {sl2category}
                                </Node>
                            );
                        })}
                    </Module>
                </div>
            </li>
            ) : null}

            {navTitle3 ? (
            <li className="navbar-item">
                <a>
                    <span>{navTitle3}</span>
                </a>
                <div className="submenu">
                    <Module {...Slot3List}>
                        { sl3categories.map((sl3category: ReactNode, index: number) => {
                            return (
                                <Node {...Slot3ListItem} key={index}>
                                    {sl3category}
                                </Node>
                            );
                        })}
                    </Module>
                </div>
            </li>
            ) : null}

            {navTitle4 ? (
            <li className="navbar-item">
                <a>
                    <span>{navTitle4}</span>
                </a>
                <div className="submenu">
                    <Module {...Slot4List}>
                        { sl4categories.map((sl4category: ReactNode, index: number) => {
                            return (
                                <Node {...Slot4ListItem} key={index}>
                                    {sl4category}
                                </Node>
                            );
                        })}
                    </Module>
                </div>
            </li>
            ) : null}

        </ul>

</>

    );
};

export default AbsoluteNavContainerView;
